import React from 'react';
import { EffectiveIntercomSettings } from '../../api/intercomSettings';

export const EffectiveBehaviorSummary: React.FC<{ effective: EffectiveIntercomSettings }> = ({ effective }) => (
  <div className="intercom-effective-summary" aria-label="Effective behavior">
    <div><span>Effective behavior</span><strong>{effective.summary?.length ? effective.summary.join(' · ') : 'No enabled access methods'}</strong></div>
    {!!effective.errors?.length && <span className="intercom-effective-summary__error">{effective.errors.length} setup issue{effective.errors.length === 1 ? '' : 's'}</span>}
    {!!effective.warnings?.length && <span className="intercom-effective-summary__warning">{effective.warnings.length} warning{effective.warnings.length === 1 ? '' : 's'}</span>}
  </div>
);
